import React, { lazy } from 'react';
import { Route, useRouteMatch, Switch } from 'react-router-dom';

const GastosView = lazy(() => import('../../container/clinica/gastos/Index'));
const GastosForm = lazy(() => import('../../container/clinica/gastos/Form'));

const GastosRoute = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
             <Route path= {`${path}/clinica/gastos/listado`} component = { GastosView } />
             <Route path={`${path}/clinica/gastos/agregar`} component = { GastosForm } />
             <Route exact path = {`${path}/clinica/gastos/editar/:id`} component = { GastosForm } />
            </Switch>
  );
};

export default GastosRoute;

